import React from 'react';
import PropTypes from 'prop-types';
import { LoadingButton, Text } from '@zillow/constellation';
import { useFormState } from 'react-hook-form';

var SimonFields = function SimonFields(_ref) {
  var buttonText = _ref.buttonText,
    children = _ref.children,
    legalText = _ref.legalText;
  var formStateProxy = useFormState();
  var formState = {
    isSubmitSuccessful: formStateProxy.isSubmitSuccessful
  };
  return !formState.isSubmitSuccessful ? /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(LoadingButton, {
    type: "submit",
    buttonType: "primary",
    disabled: formState.isSubmitting,
    loading: formState.isSubmitting
  }, buttonText), /*#__PURE__*/React.createElement(Text, {
    as: "p",
    fontType: "legal",
    marginTop: "md"
  }, legalText)) : null;
};
SimonFields.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  buttonText: PropTypes.string
} : {};
SimonFields.defaultProps = {
  buttonText: 'Subscribe',
  legalText: ''
};
var SimonFields$1 = SimonFields;

export { SimonFields$1 as default };
